import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import columnSelectorIcon from "../../../../assets/icon/column-selector.svg";
import RefillIcon from "../.././../../assets/inventory/refill.svg";
import ViewHistoryIcon from "../../../../assets/icon/pending-icon.svg";
import threeDotsIcon from "../../../../assets/icon/3-dots.svg";
import closeIcon from "../../../../assets/icon/close-icon.svg";
import CloseIcon from "../../../../assets/icon/chatClose.svg";
import TransferIcon from "../../../../assets/inventory/prescription-transfer-icon.svg";
import DiscontinueIcon from "../../../../assets/inventory/prescription-discontinue-icon.svg";
import PrescriptionsToTransfer from "./PrescriptionsToTransfer";

const Medication = () => {
  const [rSelected, setRSelected] = useState("off");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [prescriptionPopup, setPrescriptionPopup] = useState(false);

  const MedicationCheckBoxRenderer = () => {
    return (
      <div>
        <Checkbox />
      </div>
    );
  };

  const MedicationColData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex gap-2">
          <Checkbox /> <div>All</div>
        </div>
      ),
      show: true,
      cellRenderer: (rowData) => MedicationCheckBoxRenderer(rowData),
      width: 50,
    },
    {
      dataField: "orderstatus",
      text: "Order Status",
      sort: true,
      show: true,
      width: 50,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      sort: true,
      show: true,
      width: 140,
    },
    {
      dataField: "rxnumber",
      text: "Rx Number",
      sort: true,
      show: true,
      width: 50,
    },
    {
      dataField: "refillsleft",
      text: "Refills Left",
      sort: true,
      show: true,
      width: 70,
    },
    {
      dataField: "writtendate",
      text: "Written Date",
      sort: true,
      show: true,
      width: 40,
    },
    {
      dataField: "lastfilleddate",
      text: "Last Filled Date",
      sort: true,
      show: true,
      width: 50,
    },
    {
      dataField: "qty",
      text: "QTY",
      sort: true,
      show: true,
    },
  ];

  const MedicationRowData = [
    {
      orderstatus: "Packaging",
      drugname: "Metformin 500 MG Tablet",
      rxnumber: "1049401",
      refillsleft: "2",
      writtendate: "02/12/2025",
      lastfilleddate: "05/12/2025",
      qty: "90 EA",
    },
    {
      orderstatus: "Transferred Out",
      drugname: "Albuterol 90 MCG Inhaler",
      rxnumber: "1049856",
      refillsleft: "0",
      writtendate: "02/12/2025",
      lastfilleddate: "05/30/2025",
      qty: "1 EA",
    },
    {
      orderstatus: "No Refills",
      drugname: "Amlodipine 5 MG Tablet",
      rxnumber: "1047205",
      refillsleft: "0",
      writtendate: "02/12/2025",
      lastfilleddate: "05/30/2025",
      qty: "30 EA",
    },
    {
      orderstatus: "Active",
      drugname: "Atorvastatin 20 MG Tablet",
      rxnumber: "1049205",
      refillsleft: "1",
      writtendate: "06/10/2025",
      lastfilleddate: "06/10/2025",
      qty: "90 EA",
    },
    {
      orderstatus: "Active",
      drugname: "Lisinopril 10 MG Tablet",
      rxnumber: "1049382",
      refillsleft: "3",
      writtendate: "02/12/2025",
      lastfilleddate: "06/10/2025",
      qty: "30 EA",
    },
    {
      orderstatus: "Active",
      drugname: "Losartan 25 MG Tablet",
      rxnumber: "1049391",
      refillsleft: "4",
      writtendate: "02/12/2025",
      lastfilleddate: "-",
      qty: "30 EA",
    },
    {
      orderstatus: "Discontinued",
      drugname: "Trazodone 50 MG Tablet",
      rxnumber: "10441190",
      refillsleft: "0",
      writtendate: "02/12/2025",
      lastfilleddate: "25/04/2025",
      qty: "30 EA",
    },
  ];

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <div>
            <SearchButtons
              InSize={250}
              placeHolder={"Search by Document Name"}
              data={undefined}
              setFilterData={undefined}
            />
          </div>
          <Button>
            <img src={columnSelectorIcon} alt="not available" />
            Columns
          </Button>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center me-2">
          <Button color="transparent">
            <img src={ViewHistoryIcon} />
            <span style={{ color: "#702C62" }}> View History</span>
          </Button>
          <Button>
            <img src={RefillIcon} />{" "}
            <span style={{ color: "#702C62" }}> Refill </span>
          </Button>
          <Dropdown
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen(!dropdownOpen)}
            style={{ marginLeft: "12px" }}
          >
            <DropdownToggle color="primary" className="togglebtn">
              {dropdownOpen ? (
                <img src={closeIcon} alt="icon" />
              ) : (
                <img src={threeDotsIcon} alt="icon" />
              )}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem className="dropdownitem-border">
                <img src={RefillIcon} alt="icon" /> Request Refill
              </DropdownItem>
              <DropdownItem
                className="dropdownitem-border"
                onClick={() => setPrescriptionPopup(true)}
              >
                <img src={TransferIcon} alt="icon" /> Transfer
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <img src={DiscontinueIcon} alt="icon" /> Discontinue
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div>
        <Offcanvas
          style={{ width: "83.5vw" }}
          direction="end"
          isOpen={prescriptionPopup}
          toggle={() => setPrescriptionPopup(!prescriptionPopup)}
        >
          <div className="casvas-header">
            <div>Prescriptions To Tranfer (2) </div>
            <div
              className="cursor-pointer"
              onClick={() => setPrescriptionPopup(!prescriptionPopup)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div
            className="section-devider-border"
            style={{
              margin: "0px 12px 15px 18px",
            }}
          ></div>
          <OffcanvasBody>
            <PrescriptionsToTransfer />
          </OffcanvasBody>
        </Offcanvas>
      </div>
      <div className="table-card scroll-table position-relative border-0 rounded bg-white pb-0">
        <ReactStrapTable
          columns={MedicationColData}
          data={MedicationRowData}
          greenRow={[0]}
          redRow={[2]}
          yellowRow={[1]}
        />
      </div>
    </div>
  );
};

export default Medication;
